import { Button } from "@svea/design-system-components-react";
import { ButtonGroup, Dialog, Stack, useText } from "@sveabank/cc-common";
import { useNavigate } from "react-router";

type Props = {
	open: boolean;
	closeModal: () => void;
};

export const CancelClcModal = ({ open, closeModal }: Props) => {
	const [t, texts] = useText();
	const navigate = useNavigate();

	const onClose = () => {
		closeModal();
	};

	const onCancel = () => {
		closeModal();
		navigate("/dashboard");
	};

	return (
		<Dialog
			isOpen={open}
			isDismissable={false}
			center
			size="small"
			heading={t(texts.newCompany.cancelModal.heading)}
			icon="warning"
		>
			<Dialog.Content>
				<Stack gap={4}>{t(texts.newCompany.cancelModal.text)}</Stack>
			</Dialog.Content>
			<Dialog.Footer>
				<ButtonGroup>
					<Button onPress={onCancel}>{t(texts.newCompany.cancelModal.cancelButtonText)} </Button>
					<Button onPress={onClose} variant="secondary">
						{t(texts.newCompany.cancelModal.continueButtonText)}
					</Button>
				</ButtonGroup>
			</Dialog.Footer>
		</Dialog>
	);
};
